import { render, staticRenderFns } from "./DatatableDetailNew.vue?vue&type=template&id=1a82986a"
import script from "./DatatableDetailNew.vue?vue&type=script&lang=js"
export * from "./DatatableDetailNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports